<template>
  <div class="card" id="cardMetas">
    <b-card-header
      :header="comissao + ' - ' + pCardMetasValues.periodo"
      header-text-variant="white"
      header-tag="header"
      :style="style1"
    />
    <b-card class="cardBody">
      <b-row>
        <b-col cols="8" class="border-right" id="progressMeta">
          <progress-metas-vue :pProgressMetasValues="progressMetasValues"></progress-metas-vue>
        </b-col>
        <b-col cols="4" id="prevComissao">
          <label><i class="fas fa-money-check-alt mr-1"></i><b>Previsão Comissão</b></label>
          <div class="meta" id="btnVisualizar">
            <label class="mt-3 mb-3" v-if="visualizarComissao"  v-on:click="obterComissao()"><i class="fas fa-eye-slash"></i><b> R$ {{formatPrice(comissaoRep.valor)}}</b></label>
            <label class="mt-3 mb-3" v-else  v-on:click="obterComissao()"><i class="fas fa-eye"></i><b> VISUALIZAR</b></label>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <BlockUI v-if="blockUI.blockUiVisibility" :message="blockUI.msgBlockUi">
      <spinner-vue  id="modal-xl" ></spinner-vue>
    </BlockUI>
  </div>
</template>
<script>
  import ProgressMetasVue from '@/components/items/ProgressMetasVue'
  import dashboard from '@/services/dashboard'
  import { mapState } from 'vuex'
  import spinnerVue from '@/components/items/SpinnerVue'
  import { broadcastServer } from '@/main'

  export default {
    props: {
      aaa: '',
      comissao: '',
      style1: '',
      pCardMetasValues: {
        valorMeta: 0.00,
        valorAtingido: 0.00,
        periodo: ''
      }
    },
    data () {
      return {
        comissaoRep: {valor: 0.00},
        visualizarComissao: false,
        progressMetasValues: {},
        blockUI: {
          message: '',
          blockUiVisibility: false
        },
        metaAtingida: 0,
        restante: 0,
        max: 100
      }
    },
    watch: {
      pCardMetasValues: function (newVal, oldVal) { // watch it
        this.progressMetasValues = newVal
      }
    },
    components: {
      ProgressMetasVue,
      spinnerVue
    },
    computed: {
      ...mapState({
        cor: state => {
          const { cor } = state.cor
          return {
            'background-color': cor
          }
        }
      })
    },
    methods: {
      obterComissao: function () {
        this.visualizarComissao = !this.visualizarComissao
        if (this.visualizarComissao) {
          this.blockUI.blockUiVisibility = true
          this.blockUI.message = 'Buscando Comissão, aguarde...'
          dashboard.obterComissaoCorrenteRepresentante().then(response => {
            this.comissaoRep.valor = response.data.valor
          }).catch(error => {
            console.log(error)
            this.showMessage('Erro ao obter comissão!\n' + error, 'Atenção', 'danger')
          }).finally(() => {
            this.blockUI.blockUiVisibility = false
          })
        }
      },
      formatPrice (value) {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },
    created: function () {
      // console.log('card metas criado')
      broadcastServer.$on('emitBuscaDadosDashboard', parametro => {
        this.visualizarComissao = false
      })
    },
    mounted () {
    }
  }
</script>
<style scoped>
  .meta{
    font-size: 23px;
  }
  .border-right {
    border-right: 1px solid #000000;
  }
  #btnVisualizar {
    background-color: #f7f7f7;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/CardMetasVue.vue